import React, { createContext, useContext } from 'react';
import { useVWO } from '@hooks/useVWO';

const SharedVWOContext = createContext(null);

export const useVWOContext = () => useContext(SharedVWOContext);

export const VWOContextProvider = ({ children }: any) => {
    const { RecordVWOAttributes, RecordVWOEvent } = useVWO();
    return <SharedVWOContext.Provider value={{ RecordVWOAttributes, RecordVWOEvent }}>{children}</SharedVWOContext.Provider>;
};
